import { getMergedArticleFilters } from '../helpers/get-merged-article-filters'
import { FiltersQuery, useArticlesQuery, useFiltersQuery } from '@generated'
import { useRouter } from 'next/router'

// Required attributes that are used to display the product card
// And the data in the top section of the product detail page
const RCPO_ATTRIBUTE_ID_YEAR = 65 // Year
const RCPO_ATTRIBUTE_ID_MATERIAL = 62 // Material case
const RCPO_ATTRIBUTE_ID_DIAMETER = 67 // Diameter case
export const RCPO_ATTRIBUTE_ID_COLLECTION = 81 // Collection
export const requiredRCPOAttributes = [
  RCPO_ATTRIBUTE_ID_YEAR,
  RCPO_ATTRIBUTE_ID_MATERIAL,
  RCPO_ATTRIBUTE_ID_DIAMETER,
]

export type RCPOFilter = Omit<
  // @ts-ignore
  FiltersQuery['filters']['articleAttributeFilters'][0],
  'articleFilterAttributeValues'
> & {
  // @ts-ignore
  articleFilterAttributeValues: (FiltersQuery['filters']['articleAttributeFilters'][0]['articleFilterAttributeValues'][0] & {
    isAvailable: boolean
  })[]
}

export const RCPO_PAGE_SIZE = 18

export function useRCPOData() {
  const { query } = useRouter()
  const page = parseInt(query.page as string, 10) || 1

  const attributeFilters = Object.keys(query)
    // Filter out the page query parameter and only keep numeric keys
    // This way we can safely assume only attribute filters remain
    .filter((key) => key !== 'page' && /^\d+$/.test(key))
    .map((key) => {
      const values = query[key] as string
      const splitValues = values.split(',')

      return {
        attributeID: parseInt(key, 10),
        attributeValueID: [...splitValues.map((v) => parseInt(v, 10))],
      }
    })
  const [{ fetching: isFetchingDefaultFilters, data: defaultFilterData }] = useFiltersQuery({
    variables: {
      filters: {
        webID: 'gpcpreown',
        collections: [1],
        brands: [150],
      },
    },
  })
  const [{ fetching: isFetchingFilters, data: filterData }] = useFiltersQuery({
    variables: {
      filters: {
        webID: 'gpcpreown',
        collections: [1],
        brands: [150],
        attributeFilters,
      },
    },
  })
  const [{ fetching: isFetchingArticles, data: articleData }] = useArticlesQuery({
    variables: {
      filters: {
        webID: 'gpcpreown',
        collections: [1],
        brands: [150],
        attributeFilters,
      },
      pagination: {
        limit: RCPO_PAGE_SIZE,
        skip: (page - 1) * RCPO_PAGE_SIZE,
      },
    },
  })

  const mergedFilters = getMergedArticleFilters(
    defaultFilterData as FiltersQuery,
    filterData as FiltersQuery,
  )

  return {
    fetching: isFetchingFilters || isFetchingDefaultFilters || isFetchingArticles,
    filters: mergedFilters,
    items: articleData?.articles?.items || [],
    totalCount: articleData?.articles?.total || 0,
    page,
  }
}
